// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"7a4384df29c3e93bc01f","883":"cf474745cf58eaa2768b"}[chunkId] + ".js";
};